/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import Select from '@tds/core-select';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Button from '@tds/core-button';
import ButtonGroup from '@tds/core-button-group';
import { InputWrapper, DateWrapper, ButtonWrapper } from './css';
import { Box, Text } from '../design/css';
import TypeAhead from '../orderDetails/typeAhead';
import MultiSelect from './multiselect';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

const WlnFilters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels,
  isOrerFullfilment = false
}) => {
  const {
    startDate,
    endDate,
    validationStartDate,
    validationEndDate,
    filterCriteria,
    assignee,
    channelId,
    province,
    productId,
    status,
    submitter,
    valueChain,
    activationLanguage,
    dealership,
    storeCode,
    channelOrgCode
  } = filterState;
  const {
    completedAt,
    createdAt,
    orderAssignedTo,
    filterByChannel,
    filterByProvince,
    filterByProducts,
    filterByStatus,
    channelName,
    filterByAssignee,
    filterBySubmitter,
    filterByOpenedDates,
    filterByValidationDates,
    filterBySalesRep,
    filterByDealership,
    filterByStoreCode,
    filterByChannelOrgCode,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    salesRepNamePlaceholder,
    filtersDropdownTitle,
    valueChainLabel,
    activationLanguageLabel,
    activationLanguagePalceHolder
  } = staticLabels;
  const {
    /*salesRepNames,*/ channels,
    assignees,
    products,
    statuses,
    submitters,
    valueChains = [],
    activationLanguages = [],
    dealerships = [],
    channelOrgCodes = [],
    storeCodes = []
  } = data;
  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));
  const productList =
    products && products.map(product => ({ label: product.text, value: product.value }));
  const statusList =
    statuses &&
    statuses.map(status => ({ label: status.text, value: status.value }));
  const valueChainsList =
    valueChains && valueChains.map(chain => ({ label: chain, value: chain }));
  const activationLanguagesList =
    activationLanguages &&
    activationLanguages.map(language => ({ label: language, value: language }));
  const dealershipsList =
    dealerships &&
    dealerships.map(dealership => ({
      label: dealership.name,
      value: dealership.id
    }));
  const channelOrgCodesList =
    channelOrgCodes &&
    channelOrgCodes.map(channelOrgCode => ({
      label: channelOrgCode,
      value: channelOrgCode
    }));
  const storeCodesList =
    storeCodes &&
    storeCodes.map(storeCode => ({ label: storeCode, value: storeCode }));
  const getButtonGroup = () => (
    <ButtonWrapper>
      <ButtonGroup
        name="filterDates"
        label=" "
        onChange={({ target: { value } }) =>
          updateFilters('filterCriteria', value)
        }
        value={filterCriteria}
      >
        <ButtonGroup.Item value="createdAt">{createdAt}</ButtonGroup.Item>
        <ButtonGroup.Item value="validatedAt">{completedAt}</ButtonGroup.Item>
      </ButtonGroup>
    </ButtonWrapper>
  );
  const multiSelectFilters = [
    {
      label: filterByProvince,
      name: 'province',
      options: [
        { label: 'Alberta', value: 'alberta' },
        { label: 'British Columbia', value: 'british_columbia' },
        { label: 'Manitoba', value: 'manitoba' },
        { label: 'New Brunswick', value: 'newBrunswick' },
        {
          label: 'Newfoundland and Labrador',
          value: 'newfoundlandAndLabrador'
        },
        { label: 'Northwest Territories', value: 'northwestTerritories' },
        { label: 'Nova Scotia', value: 'novaScotia' },
        { label: 'Nunavut', value: 'nunavut' },
        { label: 'Ontario', value: 'ontario' },
        { label: 'Prince Edward Island', value: 'princeEdwardIsland' },
        { label: 'Quebec', value: 'quebec' },
        { label: 'Saskatchewan', value: 'saskatchewan' },
        { label: 'Yukon', value: 'yukon' }
      ],
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterByProducts,
      name: 'productId',
      options: productList,
      value: productId
    },
    {
      label: filterByStatus,
      name: 'status',
      options: statusList,
      value: status
    },
    // {
    //   label: valueChainLabel,
    //   name: 'valueChain',
    //   options: valueChainsList,
    //   value: valueChain
    // },
    // {
    //   label: filterByAssignee,
    //   name: 'assignee',
    //   options: (assignees || []).map(op => ({
    //     value: op.id,
    //     label: `${op.firstName} ${op.lastName}`
    //   })),
    //   value: assignee,
    // },
    {
      label: filterBySubmitter,
      name: 'submitter',
      options: (submitters || []).map(op => ({
        value: op.id,
        label: `${op.firstName} ${op.lastName}`
      })),
      value: submitter
    },
    {
      label: filterByDealership,
      name: 'dealership',
      options: dealershipsList,
      value: dealership
    },
    {
      label: filterByStoreCode,
      name: 'storeCode',
      options: storeCodesList,
      value: storeCode
    },
    {
      label: filterByChannelOrgCode,
      name: 'channelOrgCode',
      options: channelOrgCodesList,
      value: channelOrgCode
    }
  ];
  const selectFilters = [
    // {
    //   label: activationLanguageLabel,
    //   placeholder: activationLanguagePalceHolder,
    //   options: activationLanguagesList,
    //   value: activationLanguage,
    //   onChange: ({ target: { value } }) => updateFilters('activationLanguage', value)
    // }
  ];

  const typeAheadFilters = useMemo(
    () => [
      // {
      //   label: filterByAssignee,
      //   placeholder: orderAssignedTo,
      //   options: (assignees || []).map(op => ({
      //     value: op.id,
      //     label: `${op.firstName} ${op.lastName}`
      //   })),
      //   //options: assignees,
      //   selected: assignee,
      //   onChange: value => updateFilters('assignee', value)
      // },
      // {
      //   label: filterBySubmitter,
      //   placeholder: orderAssignedTo,
      //   options: (submitters || []).map(op => ({
      //     value: op.id,
      //     label: `${op.firstName} ${op.lastName}`
      //   })),
      //   //options: assignees,
      //   selected: submitter,
      //   onChange: value => updateFilters('submitter', value)
      // },
      // {
      //   label: filterBySalesRep,
      //   placeholder: salesRepNamePlaceholder,
      //   options: (salesRepNames || []).map(op => ({
      //     value: op.id,
      //     label: `${op.firstName} ${op.lastName}`
      //   })),
      //   selected: createdBy,
      //   onChange: value => updateFilters('createdBy', value)
      // }
      {
        label: activationLanguageLabel,
        placeholder: activationLanguagePalceHolder,
        options: activationLanguagesList,
        selected: activationLanguage,
        onChange: value => updateFilters('activationLanguage', value)
      }
    ],
    // .filter(
    //   i => (i.label === filterByAssignee)
    // )
    [assignee, channels, activationLanguagesList, filterState]
  );

  const getMultiSelectFilters = listOfFilters => {
    if (!isOrerFullfilment)
      listOfFilters = listOfFilters.filter(x => x.name != 'submitter' && x.name != 'dealership' && x.name != 'storeCode' && x.name != 'channelOrgCode');
    return listOfFilters.map(({ label, options, name, value }) => {
      return (
        <div className="col-md-4">
          <MultiSelect
            updateFilters={updateFilters}
            label={label}
            options={options}
            name={name}
            value={value}
          />
        </div>
      );
    });
  };

  const getSelectFilters = listOfFilters => {
    return listOfFilters.map(
      ({ label, placeholder, options, value, onChange, defaultValue }) => {
        return (
          options && (
            <div className="col-md-4">
              <Select
                label={label}
                placeholder={placeholder}
                options={options}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
              />
            </div>
          )
        );
      }
    );
  };
  const getTypeAheadFilters = listOfFilters => {
    return listOfFilters.map(
      ({ label, placeholder, options, selected, onChange }) => {
        return (
          <div className="col-md-4">
            <TypeAhead
              label={label}
              placeholder={placeholder}
              options={options || []}
              selected={selected}
              onChange={onChange}
            />
          </div>
        );
      }
    );
  };

  const getDateFilters = () => {
    return (
      <>
        <div className="col-md-4">
          <Box
            style={{ paddingBottom: 6, paddingLeft: 0 }}
            className="col-md-12"
          >
            <Text>{filterByOpenedDates} </Text>
          </Box>
          <InputWrapper>
            <DateWrapper
              style={{ marginRight: '5px', paddingLeft: 0 }}
              className="col-md-6"
            >
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={startDateLabel}
                selected={startDate}
                onChange={value => updateFilters('startDate', value)}
              />
            </DateWrapper>
            <DateWrapper className="col-md-6">
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={endDateLabel}
                minDate={startDate}
                selected={endDate}
                onChange={value => updateFilters('endDate', value)}
              />
            </DateWrapper>
          </InputWrapper>
        </div>
        <div className="col-md-4">
          <Box
            style={{ paddingBottom: 6, paddingLeft: 0 }}
            className="col-md-12"
          >
            <Text>{filterByValidationDates} </Text>
          </Box>
          <InputWrapper>
            <DateWrapper
              style={{ marginRight: '5px', paddingLeft: 0 }}
              className="col-md-6"
            >
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={startDateLabel}
                selected={validationStartDate}
                onChange={value => updateFilters('validationStartDate', value)}
              />
            </DateWrapper>
            <DateWrapper className="col-md-6">
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={endDateLabel}
                minDate={validationStartDate}
                selected={validationEndDate}
                onChange={value => updateFilters('validationEndDate', value)}
              />
            </DateWrapper>
          </InputWrapper>
        </div>
      </>
    );
  };
  return (
    <ExpandCollapse topDivider={false}>
      <ExpandCollapse.Panel id="filters" header={filtersDropdownTitle}>
        <div className="row">
          {getSelectFilters(selectFilters)}
          {getTypeAheadFilters(typeAheadFilters)}
          {getDateFilters()}
          {getMultiSelectFilters(multiSelectFilters)}
        </div>

        <Box
          display="flex"
          justifyContent="center"
          flexDirection="row"
          pt={64}
          mdJustifyContent="flex-start"
          mdWidth={100}
          mdPadding="16px 0"
          margin="0 auto"
        >
          <Button onClick={onApplyFilters} variant="secondary">
            {buttonApply}
          </Button>
          <Box width="2"> </Box>
          <Button onClick={onResetFilters}>{buttonReset}</Button>
        </Box>
      </ExpandCollapse.Panel>
    </ExpandCollapse>
  );
};

export default WlnFilters;

WlnFilters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    filterStatus: PropTypes.string,
    startDate: PropTypes.dateFormat,
    endDate: PropTypes.dateFormat,
    filterCriteria: PropTypes.string,
    assignee: PropTypes.array,
    submitter: PropTypes.array,
    channelId: PropTypes.string,
    province: PropTypes.string,
    dealership: PropTypes.string,
    channelOrgCode: PropTypes.string,
    outletCode: PropTypes.string,
    createdBy: PropTypes.string,
    products: PropTypes.string
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
